import { MapPinIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { AddressBlockEditor } from "./editor";
import { AddressBlockEmail } from "./email";
import type { AddressBlockProps } from "./types";
import { AddressWeb } from "./web";
import { AddressWebEditor } from "./web-editor";
import { AddressEmailPanelRenderer } from "./email-panel";


export default registerBlock<AddressBlockProps>({
  type: "delivery-address",
  name: "editorBlocksLibrary.blocks.delivery-address.title",
  description: "editorBlocksLibrary.blocks.delivery-address.description",
  Icon: MapPinIcon,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    email: {
      component: AddressBlockEmail,
      editor: {
        component: AddressBlockEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: AddressEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: AddressWeb,
      editor: {
        component: AddressWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: {
          minSize: 6,
        },
      },
    },
  },
});
